import { NavLink } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getArchiveStudies } from '../api/studiesAPI';
import Loader from './ui/Loader';
import Button from './ui/Button';

import './ArchiveTable.scss';

const ArchiveTable = () => {
	const { isLoading, isError, error, data } = useQuery({
		queryKey: ['archives'],
		queryFn: getArchiveStudies,
		staleTime: 3000000 //5 minutes to refetch
	});
	let pageContent = null;
	if (isLoading) {
		pageContent = <Loader centered />;
	} else if (isError) {
		pageContent = (
			<div>Error fetching post: {error.message}</div>
		);
	} else {
		const { studies } = data.data;
		pageContent = (
			<table className='table table-bordered  table-hover'>
				<thead className='table-secondary'>
					<tr>
						<th>Study Name</th>
						<th>Sponsor Name</th>
						<th>P.I. Name</th>
						<th>Submitted</th>
						<th>Approved</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{studies.map((s) => (
						<tr key={s._id}>
							<td className='td-archive-title'>
								{s.title}
							</td>
							<td>{s.sponsor}</td>
							<td>{s?.pi?.firstname || ''}</td>
							<td>{s.createdAt.split('T')[0]}</td>
							<td>{s.updatedAt.split('T')[0]}</td>
							<td>
								<NavLink to={`/trials-archive/${s._id}`}>
									<Button className='primary-button'>
										See Study
									</Button>
								</NavLink>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		);
	}
	return (
		<div className='archive-table-container'>
			<h2>Archive</h2>
			{pageContent}
		</div>
	);
};

export default ArchiveTable;
